// Access token storage. "Remember this device" keeps it in localStorage (30-day token);
// otherwise sessionStorage, so it ends with the browser session. Both work in a
// Capacitor WebView.
const KEY = 'keeper.session';
const VENUE_KEY = 'keeper.lastVenue';

type Listener = () => void;
const listeners = new Set<Listener>();

function stores(): Storage[] {
  const out: Storage[] = [];
  try {
    out.push(localStorage);
  } catch {
    /* unavailable */
  }
  try {
    out.push(sessionStorage);
  } catch {
    /* unavailable */
  }
  return out;
}

function read(): string | null {
  for (const s of stores()) {
    const v = s.getItem(KEY);
    if (v) return v;
  }
  return null;
}

export const session = {
  token: read,
  set(token: string, remember: boolean) {
    for (const s of stores()) s.removeItem(KEY);
    try {
      (remember ? localStorage : sessionStorage).setItem(KEY, token);
    } catch {
      /* storage unavailable: session lasts for this page only */
    }
    listeners.forEach((l) => l());
  },
  clear() {
    for (const s of stores()) s.removeItem(KEY);
    listeners.forEach((l) => l());
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  /** Venue shown on the sign-in screen next time (not sensitive: name only). */
  lastVenue(): string | null {
    try {
      return localStorage.getItem(VENUE_KEY);
    } catch {
      return null;
    }
  },
  rememberVenue(name: string) {
    try {
      localStorage.setItem(VENUE_KEY, name);
    } catch {
      /* ignore */
    }
  },
};
